export const LOAD_DATA = 'LOAD_DATA'
export const SELEZIONA_DETTAGLIO_CRIMINE = 'SELEZIONA_DETTAGLIO_CRIMINE'
export const PULISCI_DETTAGLIO_CRIMINE = 'PULISCI_DETTAGLIO_CRIMINE'
export const DEFINISCI_STATI_RAPINA = 'DEFINISCI_STATI_RAPINA'

export const DEFINISCI_STATI_INTERVENTI_RAPINA =
  'DEFINISCI_STATI_INTERVENTI_RAPINA'
export const DEFINISCI_STATI_BOTTINO_RAPINA = 'DEFINISCI_STATI_BOTTINO_RAPINA'
export const DEFINISCI_STATI_CONSEGUENZE_RAPINA =
  'DEFINISCI_STATI_CONSEGUENZE_RAPINA'

export const DEFINISCI_STATI_FURTO = 'DEFINISCI_STATI_FURTO'
export const DEFINISCI_STATI_INTERVENTI_FURTO =
  'DEFINISCI_STATI_INTERVENTI_FURTO'
export const DEFINISCI_STATI_BOTTINO_FURTO = 'DEFINISCI_STATI_BOTTINO_FURTO'
export const DEFINISCI_STATI_CONSEGUENZE_FURTO =
  'DEFINISCI_STATI_CONSEGUENZE_FURTO'

export const DEFINISCI_STATI_MODALITA = 'DEFINISCI_STATI_MODALITA'
export const DEFINISCI_STATI_COSTI_EVENTO = 'DEFINISCI_STATI_COSTI_EVENTO'
export const DEFINISCI_STATI_OSTAGGI = 'DEFINISCI_STATI_OSTAGGI'
export const DEFINISCI_STATI_ALTRIEVENTI = 'DEFINISCI_STATI_ALTRIEVENTI'

export const UTENTE_AUTENTICATO = 'UTENTE_AUTENTICATO'
export const UTENTE_DISCONNESSO = 'UTENTE_DISCONNESSO'
